import { useMemo } from "react";
import useSWR from "swr";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { ServicesURL } from "@utils/utilsApi";
import { LOSearchCondition, LOSearchOrderBy } from "./types";

interface UseLOSearchParams {
  corporateId: string;
  conditions: LOSearchCondition[];
  orderBy: LOSearchOrderBy[];
  page: number;
  pageSize: number;
  enabled?: boolean;
  catalogueFilters?: Record<string, unknown>;
}

export const useLOSearch = ({
  corporateId,
  conditions,
  orderBy,
  page,
  pageSize,
  enabled = true,
  catalogueFilters,
}: UseLOSearchParams) => {
  const url =
    enabled && corporateId
      ? ServicesURL.getAggregatedLO.replace(":idCorporate", corporateId)
      : null;

  const body = useMemo(
    () => ({
      conditions,
      orderBy,
      page: Math.max(page - 1, 0),
      size: pageSize,
      ...(catalogueFilters ? { catalogueFilters } : {}),
    }),
    [conditions, orderBy, page, pageSize, catalogueFilters],
  );

  const { data, isLoading, error, mutate } = useSWR(
    url ? [url, body] : null,
    ([u, b]: [string, typeof body]) => fetcher(u, MethodType.POST, b),
  );

  const response: any = data;
  const items: any[] = response?.output ?? [];
  const totalItems: number =
    response?.metadata?.total_elements ?? response?.metadata?.total ?? 0;
  const totalPages: number =
    response?.metadata?.total_pages ??
    Math.max(Math.ceil(totalItems / pageSize), 1);

  return { items, totalItems, totalPages, isLoading, error, mutate };
};
